export default "__VITE_ASSET__05032a0f__"